import Vue from 'vue'
import formatter from '@/utils/formatter'

Vue.filter('cpf', formatter.formatCPF)
